import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
    selector: "love-it-select-boolean",
    templateUrl: "./select-boolean.component.html",
    styleUrls: ["./select-boolean.component.scss"],
    standalone: false
})
export class SelectBooleanComponent implements OnInit {
  @Input() booleanFc: FormControl;
  @Input() clearable = true;

  constructor() {}

  ngOnInit(): void {}
}
